import { create } from "zustand";

export interface ToastState {
  isVisible: boolean;
  title?: string;
  description?: string;
  content: React.ReactNode | null;
  isExpanded: boolean;
  id: string; // unique id for the toast
}

interface ToastStore {
  // State
  isVisible: boolean;
  title?: string;
  description?: string;
  content: React.ReactNode | null;
  isExpanded: boolean;
  id: string;

  // Actions
  showToast: (toast: Omit<ToastState, "isVisible" | "isExpanded">) => void;
  closeToast: () => void; // Completely removes the toast (resets state)
  toggleExpand: () => void;
}

export const useToastStore = create<ToastStore>((set) => ({
  // Initial state
  isVisible: false,
  title: "",
  description: "",
  content: null,
  isExpanded: true,
  id: "",

  // Actions
  showToast: (toast) =>
    set({
      isVisible: true,
      title: toast.title,
      description: toast.description,
      content: toast.content,
      isExpanded: true, // Start expanded by default
      id: toast.id || Date.now().toString(),
    }),
  closeToast: () =>
    set({
      isVisible: false,
      title: "",
      description: "",
      content: null,
      isExpanded: true,
      id: "",
    }), // Completely reset the toast state
  toggleExpand: () => set((state) => ({ isExpanded: !state.isExpanded })),
}));
